export enum EPopClientMessageType {
    BASIC_G2W_INITIALIZATION_REQUEST = 'ucip.basic.g2wInitializationRequest',
    BASIC_G2W_INITIALIZATION_RESPONSE = 'ucip.basic.w2gInitializationResponse',
    LOADINGSTATUS_G2W_START_NOTIFICATION = 'ucip.loadingstatus.g2wLoadingStartNotification',
    LOADINGSTATUS_G2W_PROGRESS_NOTIFICATION = 'ucip.loadingstatus.g2wLoadingProgressNotification',
    LOADINGSTATUS_G2W_END_NOTIFICATION = 'ucip.loadingstatus.g2wLoadingEndNotification',
    LOADINGSTATUS_G2W_GAME_READY_NOTIFICATION = 'ucip.loadingstatus.g2wGameReadyNotification',
    AUTOPLAY_G2W_AUTOPLAY_START_NOTIFICATION = 'ucip.autoplay.g2wAutoplayStartNotification',
    AUTOPLAY_G2W_AUTOPLAY_END_NOTIFICATION = 'ucip.autoplay.g2wAutoplayEndNotification',
    SOUND_G2W_SOUND_UPDATE_NOTIFICATION = 'ucip.sound.g2wSoundUpdateNotification',
    GAMEROUND_G2W_GAME_ROUND_START_NOTIFICATION = 'ucip.gameround.g2wGameRoundStartNotification',
    GAMEROUND_G2W_GAME_ROUND_END_NOTIFICATION = 'ucip.gameround.g2wGameRoundEndNotification',
    BETUPDATE_G2W_GAME_UPDATE_NOTIFICATION = 'ucip.betupdate.g2wBetUpdateNotification',
    OPENPAGE_G2W_OPEN_PAGE_COMMAND = 'ucip.openpage.g2wOpenPageCommand',
    CLOSEGAME_W2G_CLOSE_GAME_RESPONSE = 'ucip.closegame.w2gCloseGameRequest',
    CLOSEGAME_G2W_CLOSE_GAME_ERROR_RESPONSE = 'ucip.closegame.g2wCloseGameErrorResponse',
    CLOSEGAME_G2W_BASIC_GAME_FRAME_COMMAND = 'ucip.basic.g2wCloseGameFrameCommand',
    ERRORS_G2W_ERROR_NOTIFICATION = 'ucip.errors.g2wErrorNotification',
    BALANCEUPDATE_G2W_BALANCE_UPDATE_NOTIFICATION = 'ucip.balanceupdate.g2wBalanceUpdateNotification',
    DISPLAYSTATUS_G2W_UI_STATE_NOTIFICATION = 'ucip.displaystatus.g2wUiStateNotification',
    PAUSE_G2W_PAUSE_NOTIFICATION = 'ucip.pause.g2wPauseNotification',

    AUTOPLAY_W2G_INTERRUPT_GAMEPLAY_COMMAND = 'ucip.autoplay.w2gInterruptGameplayCommand',
    PAUSE_W2G_PAUSE_COMMAND = 'ucip.pause.w2gPauseCommand',
    DISPLAYSTATUS_W2G_VISIBILITY_CHANGE_NOTIFICATION = 'ucip.displaystatus.w2gVisibilityChangeNotification',
    SOUND_W2G_SOUND_UPDATE_NOTIFICATION = 'ucip.sound.w2gSoundUpdateNotification',
    BALANCEREFRESH_W2G_REFRESH_BALANCE_COMMAND = 'ucip.balancerefresh.w2gRefreshBalanceCommand',
    CLOSEGAME_W2G_CLOSE_GAME_REQUEST = 'ucip.closegame.w2gCloseGameRequest'
}

export enum EPopNotificationError {
    GENERIC_ERROR = 'GENERIC_ERROR',
    AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
    CONNECTION_ERROR = 'CONNECTION_ERROR',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS'
}

export enum EDelegatedPages {
    DEPOSIT = 'deposit',
    RESPONSIBLE_GAMING = 'responsible_gaming',
    HELP = 'help',
    SUPPORT = 'support',
    GAME_HISTORY = 'game_history'
}
export interface IOpenPageData {
    pageID: EDelegatedPages;
    url: string;
}

export interface IPopClientMessage {
    _type: EPopClientMessageType;
    version?: string;
    features?: string[];
    progress?: number;
    totalBet?: string;
    mute?: boolean;
    level?: number;
    pageID?: EDelegatedPages;
    url?: string;
    pause?: boolean;
    visible?: boolean;
    busy?: boolean;
    error?: {
        type: undefined | EPopNotificationError;
        description: string;
    };
    balance?: {
        value: number;
        winAmount: number;
    };
}
